<script setup lang="ts">
import { useToast } from '@lib/composables/useToast'
import { CheckCircle2, Info, AlertTriangle, XCircle, X } from 'lucide-vue-next'

const { toasts, remove } = useToast()

const iconMap = {
    success: CheckCircle2,
    info: Info,
    warn: AlertTriangle,
    error: XCircle
} as const

const colorMap = {
    success: 'border-l-green text-green',
    info: 'border-l-blue text-blue',
    warn: 'border-l-yellow text-yellow',
    error: 'border-l-red text-red'
} as const
</script>

<template>
    <div class="fixed top-4 right-4 z-toast flex flex-col gap-2 max-w-sm">
        <transition-group name="toast">
            <div
                v-for="t in toasts"
                :key="t.id"
                :class="[
                    'flex items-start gap-3 px-4 py-3 rounded-8 shadow-e3 bg-white border-l-4',
                    colorMap[t.severity]
                ]"
            >
                <component :is="iconMap[t.severity]" class="flex-none w-5 h-5 mt-0.5" />
                <div class="flex-1 min-w-0">
                    <div v-if="t.summary" class="text-sm font-semibold text-ink">{{ t.summary }}</div>
                    <div v-if="t.detail" class="mt-0.5 text-xs text-gray-600">{{ t.detail }}</div>
                </div>
                <button
                    type="button"
                    class="flex-none w-6 h-6 rounded-4 text-gray-400 hover:text-gray-700"
                    @click="remove(t.id)"
                >
                    <X class="w-4 h-4" />
                </button>
            </div>
        </transition-group>
    </div>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
    transition: all 220ms ease;
}
.toast-enter-from,
.toast-leave-to {
    opacity: 0;
    transform: translateX(20px);
}
</style>
